export enum VisitSectionTypes {
  None = 0,
  Intake = 1,
  Subjective = 2,
  Vitals = 3,
  Objective = 4,
  Assessment = 5,
  Plan = 6,
  Prognosis = 7,
  VisitBuilder = 9,
  Discharge = 10,
  AttachmentsandConsents = 11,
  Assignment = 12,
  Signature = 13,
  PostVisit = 14,
  PrivateNotes = 15,
  Diagnostics = 16,

  // This enum value is only used on the FrontEnd.
  // We need this so we're able to store information about objective notes
  // whilst saving objective values(normal/abnormal/etc..)
  // It is not stored in the DB nor it is stored/used on the backend.
  ObjectiveWithoutNotes = 999,
}
